export default "__VITE_ASSET__CK7TQnbO__"